export enum EPhoneDisplayType {
    proxy = "proxy",
    personal = "personal",
  }
  
  export const phoneDisplayTypeAsString = (
    phoneDisplayType: EPhoneDisplayType | string
  ): string => {
    switch (phoneDisplayType) {
      case EPhoneDisplayType.proxy:
        return "N° Leedflow";
      case EPhoneDisplayType.personal:
        return "N° Personnel";
      default:
        return phoneDisplayType.toString();
    }
  };
  